// Character count of translated HTML, for the translator's page/price
// calculator. Counts visible characters including spaces (the "standard page"
// convention) with runs of whitespace collapsed, so markup and line breaks
// don't inflate the number.
export function countChars(html) {
  if (!html) return 0;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = doc.body.textContent || '';
  return text.replace(/\s+/g, ' ').trim().length;
}

// Word count of translated HTML, for per-word pricing. Splits the visible
// text on whitespace. Meaningless for scriptio-continua languages (zh/ja/th),
// but per-word pricing is a Latin/Cyrillic-market convention anyway.
export function countWords(html) {
  if (!html) return 0;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const text = (doc.body.textContent || '').trim();
  return text ? text.split(/\s+/).length : 0;
}

// Base language code: `pt-BR` -> `pt`, so a rate set for `pt` matches a
// `pt-BR` document and vice versa.
export function baseLang(code) {
  return (code || '').toLowerCase().split('-')[0];
}
